(function () {
  var section = document.querySelector('[data-pack-section]');
  if (!section) return;

  var TIERS = [
    { count: parseInt(section.dataset.tier1Count, 10), pct: parseFloat(section.dataset.tier1Pct) },
    { count: parseInt(section.dataset.tier2Count, 10), pct: parseFloat(section.dataset.tier2Pct) }
  ].filter(function (t) { return t.count > 0; })
   .sort(function (a, b) { return a.count - b.count; });

  var grid = section.querySelector('[data-pack-grid]');
  var itemsContainer = section.querySelector('[data-pack-items]');
  var itemsContainerMobile = section.querySelector('[data-pack-items-mobile]');
  var skeletonsEl = section.querySelector('[data-pack-skeletons]');
  var countEl = section.querySelector('[data-pack-count]');
  var countMobileEl = section.querySelector('[data-pack-count-mobile]');
  var countSuffixEl = section.querySelector('[data-pack-count-suffix]');
  var countSuffixMobileEl = section.querySelector('[data-pack-count-suffix-mobile]');
  var totalEl = section.querySelector('[data-pack-total]');
  var totalMobileEl = section.querySelector('[data-pack-total-mobile]');
  var subtitleEl = section.querySelector('[data-pack-subtitle]');
  var subtitleMobileEl = section.querySelector('[data-pack-subtitle-mobile]');
  var savingsEl = section.querySelector('[data-pack-savings]');
  var savingsMobileEl = section.querySelector('[data-pack-savings-mobile]');
  var cta = section.querySelector('[data-pack-add-cart]');
  var ctaMobile = section.querySelector('[data-pack-add-cart-mobile]');
  var ctaOriginalLabel = cta ? cta.textContent.trim() : 'AÑADIR';

  var progressFills = [
    section.querySelector('[data-progress-fill="1"]'),
    section.querySelector('[data-progress-fill="2"]')
  ];
  var progressFillsMobile = [
    section.querySelector('[data-progress-fill-mobile="1"]'),
    section.querySelector('[data-progress-fill-mobile="2"]')
  ];
  var progressLabels = [
    section.querySelector('[data-progress-label="1"]'),
    section.querySelector('[data-progress-label="2"]')
  ];
  var progressLabelsMobile = [
    section.querySelector('[data-progress-label-mobile="1"]'),
    section.querySelector('[data-progress-label-mobile="2"]')
  ];

  var mobileFooter = section.querySelector('[data-pack-mobile-footer]');
  var mobileToggle = section.querySelector('[data-pack-mobile-toggle]');

  /* State: each entry = { variantId, productId, title, image, price (cents), qty } */
  var packItems = [];

  /* ── Intercept quick-add forms inside this section ── */
  grid.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"], form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var card = form.closest('[data-pack-product]');
    if (!card) return;
    if (card.dataset.available === 'false') return;

    var variantId = card.dataset.variantId;
    var productId = card.dataset.productId;
    var title = card.dataset.productTitle;
    var image = card.dataset.productImage;
    var price = parseInt(card.dataset.variantPrice, 10) || 0;

    var existing = findItem(variantId);
    if (existing) {
      existing.qty += 1;
    } else {
      packItems.push({ variantId: variantId, productId: productId, title: title, image: image, price: price, qty: 1 });
    }

    var btn = form.querySelector('button[type="submit"], button[name="add"]');
    if (btn) {
      btn.classList.remove('is-added');
      void btn.offsetWidth;
      btn.classList.add('is-added');
    }

    updateUI();
  }, true);

  function findItem(variantId) {
    for (var i = 0; i < packItems.length; i++) {
      if (packItems[i].variantId === variantId) return packItems[i];
    }
    return null;
  }

  function removeItem(variantId) {
    for (var i = 0; i < packItems.length; i++) {
      if (packItems[i].variantId !== variantId) continue;
      if (packItems[i].qty > 1) {
        packItems[i].qty -= 1;
      } else {
        packItems.splice(i, 1);
      }
      break;
    }
    updateUI();
  }

  function addItem(variantId) {
    var it = findItem(variantId);
    if (it) {
      it.qty += 1;
      updateUI();
    }
  }

  function getDiscountPct(qty) {
    var pct = 0;
    for (var i = 0; i < TIERS.length; i++) {
      if (qty >= TIERS[i].count) pct = TIERS[i].pct;
    }
    return pct;
  }

  function getNextTier(qty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (qty < TIERS[i].count) return TIERS[i];
    }
    return null;
  }

  function formatMoney(cents) {
    var euros = cents / 100;
    return euros.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function buildSubtitle(qty) {
    var nextTier = getNextTier(qty);
    if (!nextTier) {
      var topTier = TIERS[TIERS.length - 1];
      return '¡Descuento máximo aplicado! <strong>' + topTier.pct + '% OFF</strong>';
    }
    var remaining = nextTier.count - qty;
    var noun = remaining === 1 ? 'producto' : 'productos';
    return 'Añade ' + remaining + ' ' + noun + ' más y obtén: <strong>' + nextTier.pct + '% OFF</strong>';
  }

  function updateUI() {
    var qty = packItems.reduce(function (s, i) { return s + i.qty; }, 0);
    var subtotal = packItems.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
    var pct = getDiscountPct(qty);
    var total = Math.round(subtotal * (1 - pct / 100));
    var savings = subtotal - total;

    if (countEl) countEl.textContent = qty;
    if (countMobileEl) countMobileEl.textContent = qty;
    var suffix = qty === 1 ? 'producto' : 'productos';
    if (countSuffixEl) countSuffixEl.textContent = suffix;
    if (countSuffixMobileEl) countSuffixMobileEl.textContent = suffix;

    if (skeletonsEl) skeletonsEl.style.display = qty > 0 ? 'none' : '';

    if (totalEl) totalEl.textContent = formatMoney(total);
    if (totalMobileEl) totalMobileEl.textContent = formatMoney(total);

    var copy = buildSubtitle(qty);
    if (subtitleEl) subtitleEl.innerHTML = copy;
    if (subtitleMobileEl) subtitleMobileEl.innerHTML = copy;

    [progressFills, progressFillsMobile].forEach(function (fills) {
      fills.forEach(function (fill, i) {
        if (!fill || !TIERS[i]) return;
        var tierStart = i === 0 ? 0 : TIERS[i - 1].count;
        var tierEnd = TIERS[i].count;
        var range = tierEnd - tierStart;
        var p = Math.min(Math.max((qty - tierStart) / range, 0), 1);
        fill.style.width = (p * 100) + '%';
      });
    });

    [progressLabels, progressLabelsMobile].forEach(function (labels) {
      labels.forEach(function (label, i) {
        if (!label || !TIERS[i]) return;
        var tierStart = i === 0 ? 0 : TIERS[i - 1].count;
        var tierEnd = TIERS[i].count;
        var active = qty >= tierEnd || (qty > tierStart && qty < tierEnd);
        label.classList.toggle('is-active', active);
      });
    });

    [savingsEl, savingsMobileEl].forEach(function (el) {
      if (!el) return;
      if (pct > 0 && savings > 0) {
        el.innerHTML = 'Te ahorras <strong>' + formatMoney(savings) + '</strong>';
        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    });

    var canAdd = TIERS.length > 0 ? qty >= TIERS[0].count : qty > 0;
    if (cta) cta.disabled = !canAdd;
    if (ctaMobile) ctaMobile.disabled = !canAdd;

    renderItems();
  }

  function createItemEl(item) {
    var div = document.createElement('div');
    div.className = 'aceites-create-pack__item';
    div.dataset.variantId = item.variantId;

    var img = item.image ? '<img class="aceites-create-pack__item-img" src="' + item.image + '" alt="" width="44" height="44" loading="lazy">' : '';

    div.innerHTML =
      '<div class="aceites-create-pack__item-img-wrap">' + img + '</div>' +
      '<div class="aceites-create-pack__item-details">' +
        '<span class="aceites-create-pack__item-title"></span>' +
        '<span class="aceites-create-pack__item-price"></span>' +
      '</div>' +
      '<div class="aceites-create-pack__item-qty">' +
        '<button type="button" class="aceites-create-pack__item-qty-btn" data-remove>−</button>' +
        '<span class="aceites-create-pack__item-qty-val"></span>' +
        '<button type="button" class="aceites-create-pack__item-qty-btn" data-add>+</button>' +
      '</div>';

    div.querySelector('.aceites-create-pack__item-title').textContent = item.title;
    div.querySelector('[data-remove]').addEventListener('click', function () { removeItem(item.variantId); });
    div.querySelector('[data-add]').addEventListener('click', function () { addItem(item.variantId); });

    return div;
  }

  function renderItems() {
    [itemsContainer, itemsContainerMobile].forEach(function (container) {
      if (!container) return;

      var existingEls = Array.prototype.slice.call(container.querySelectorAll('.aceites-create-pack__item'));
      var targetIds = packItems.map(function (i) { return i.variantId; });

      existingEls.forEach(function (el) {
        if (targetIds.indexOf(el.dataset.variantId) === -1) {
          el.classList.add('is-removing');
          setTimeout(function () { if (el.parentNode) el.remove(); }, 260);
        }
      });

      packItems.forEach(function (item) {
        var existing = container.querySelector('.aceites-create-pack__item[data-variant-id="' + item.variantId + '"]');
        if (existing) {
          existing.querySelector('.aceites-create-pack__item-qty-val').textContent = item.qty;
          existing.querySelector('.aceites-create-pack__item-price').textContent = formatMoney(item.price * item.qty);
        } else {
          var el = createItemEl(item);
          el.querySelector('.aceites-create-pack__item-qty-val').textContent = item.qty;
          el.querySelector('.aceites-create-pack__item-price').textContent = formatMoney(item.price * item.qty);
          container.appendChild(el);
        }
      });
    });
  }

  /* Mobile toggle */
  if (mobileToggle && mobileFooter) {
    mobileToggle.addEventListener('click', function () {
      var expanded = mobileFooter.classList.toggle('is-expanded');
      mobileToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  /* Add to cart */
  function addToCart() {
    var qty = packItems.reduce(function (s, i) { return s + i.qty; }, 0);
    if (TIERS.length > 0 && qty < TIERS[0].count) return;
    if (qty === 0) return;

    var discount = getDiscountPct(qty);
    var packId = 'pack-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

    var items = packItems.map(function (it) {
      var props = { '_pack_id': packId };
      if (discount > 0) props['_pack_discount'] = discount + '%';
      return { id: parseInt(it.variantId, 10), quantity: it.qty, properties: props };
    });

    [cta, ctaMobile].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = true;
      btn.textContent = 'AÑADIENDO…';
    });

    var payload = { items: items };
    var done = function () {
      packItems = [];
      updateUI();
      [cta, ctaMobile].forEach(function (btn) { if (btn) btn.textContent = ctaOriginalLabel; });
      if (mobileFooter) mobileFooter.classList.remove('is-expanded');
    };

    var p;
    if (window.AceitesCart && typeof window.AceitesCart.add === 'function') {
      p = window.AceitesCart.add(payload);
    } else {
      p = fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart_add_failed');
        return r.json();
      }).then(function () {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      });
    }

    Promise.resolve(p)
      .then(done)
      .catch(function (err) {
        console.error('Pack add to cart error:', err);
        [cta, ctaMobile].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = false;
          btn.textContent = ctaOriginalLabel;
        });
      });
  }

  if (cta) cta.addEventListener('click', addToCart);
  if (ctaMobile) ctaMobile.addEventListener('click', addToCart);

  updateUI();
})();
